import React from 'react';
import { Link } from 'react-router-dom';

import { RoutePath } from 'enums/Routes';

type RenderDescriptionWithLinkOptions = {
  description: string;
  keyword: string;
  route: RoutePath;
  className?: string;
  state?: object;
};

export const renderDescriptionWithLink = ({
  description,
  keyword,
  route,
  className,
  state,
}: RenderDescriptionWithLinkOptions): React.ReactNode => {
  if (description.includes(keyword)) {
    const parts = description.split(keyword);
    return (
      <>
        {parts.map((part, index) => (
          <React.Fragment key={index}>
            {part}
            {index < parts.length - 1 && (
              <Link to={route} state={state} className={className}>
                {keyword}
              </Link>
            )}
          </React.Fragment>
        ))}
      </>
    );
  }
  return description;
};
